export default __webpack_public_path__ + "static/media/PatternsMobile.f5723b99.svg";